import React, { useState } from 'react';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import useAuth from '../../hooks/useAuth';
import menuItems from '../../menu-items';

const AuthGuard = ({ children }) => {
  //console.log("WNBDHJCNCC");
  const { isLoggedIn } = useAuth();
  const [i,setI] = useState(false)
  const navigate = useNavigate();
  
  const location = useLocation();
  console.log(location);

  // const data = menuItems.items.filter(item => item.type)



  useEffect(() => {
    var logOutFalse=localStorage.getItem("key")
    //console.log(logOutFalse,"-----------------------------");
    if (logOutFalse == "false" || logOutFalse == null) {
      navigate('/auth/signin-1');
      setI(false)
    }else{
      // navigate("/dashboard")
      setI(true)
    }
  }, []);
  return i?<>{children}</>:null
 
};

export default AuthGuard;
